export default __webpack_public_path__ + "static/media/Bg1.a1cd602d.svg";